module.exports = __webpack_public_path__ + "static/media/29FUNOV8.da212eca.jpg";